import { FC, useEffect } from 'react';

import styled from '@emotion/styled';
import { toastr } from 'react-redux-toastr';

import { ServerError } from '@britishcouncil/react-forms';

import { ServerErrors } from './ServerErrors';

const DEFAULT_TOASTR_ERROR = 'Please fix all validation errors first';

export const FormFooter: FC<{
  mainErrors?: ServerError[];
  toastrError?: string;
  submitCount?: number;
  isValid?: boolean;
}> = ({ children, mainErrors, toastrError, submitCount, isValid }) => {
  useEffect(() => {
    if (submitCount && submitCount > 0 && !isValid) {
      toastr.error('Error', toastrError ?? DEFAULT_TOASTR_ERROR);
    }
  }, [isValid, submitCount, toastrError]);

  return (
    <div>
      {!!mainErrors && <ServerErrors errors={mainErrors} />}
      <ButtonsBox>{children}</ButtonsBox>
    </div>
  );
};

export const ButtonsBox = styled.div`
  text-align: center;

  button {
    margin-bottom: 10px;
  }

  @media (min-width: 850px) {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`;
